module.exports = __webpack_public_path__ + "img/motto-mortgage-social-white-blue.cd5a2120.jpg";